import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../../helper/api";
import { toast } from "react-toastify";

export const listPayout = createAsyncThunk("user/listPayout", async (payload) => {

  const response = await api.post("admin/payouttable/list", payload);
 
  return response.data;
});

const listPayoutSlice = createSlice({
  name: "user",
  initialState: {
    data:null,
    loading: false,
    error: null,
  },
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: {
      ignoredPaths: ["payload.headers"],
    },
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listPayout.pending, (state) => {
        state.loading = true;
      })
      .addCase(listPayout.fulfilled, (state, action) => {
   
        state.loading = false;
        state.data = action.payload;
        
      })
      .addCase(listPayout.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        toast.error(action.error.message);
      });
  },
});

export default listPayoutSlice.reducer;
